<template>
  <div
    :class="type"
    class="alert-card"
  >
    <div class="alert-card__title f">
      <svg
        height="20"
        width="20"
      >
        <use :xlink:href="`/icons/sprite.svg#i-${icon || type}`" />
      </svg>
      <span class="fg">{{ title }}</span>
    </div>
    <div class="alert-card__description">
      {{ description }}
    </div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    type?: 'warning' | 'error' | 'success' | 'info'
    title: string
    description: string
    icon?: string
  }>(),
  {
    type: 'warning',
    icon: 'warning',
  },
);
</script>

<style lang="scss" scoped>
.alert-card {
  background-color: #252930;
  border-radius: 12px;
  padding: 12px;

  &__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    gap: 8px;
  }

  &__description {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    opacity: 0.7;
    margin-top: 6px;
  }

  &.warning {
    background-color: var(--attention);
    color: var(--on-attention);
  }

  &.error {
    background-color: #302323;
    color: var(--destructive);
  }
}
</style>
